import { createGlobalStyle, keyframes, css } from 'styled-components';

/** Slow drift for the background blobs. */
export const float = keyframes`
  0%, 100% { transform: translate3d(0, 0, 0) scale(1); }
  50%      { transform: translate3d(0, -22px, 0) scale(1.05); }
`;

export const pop = keyframes`
  0%   { transform: scale(0.82); opacity: 0; }
  60%  { transform: scale(1.06); opacity: 1; }
  100% { transform: scale(1);    opacity: 1; }
`;

export const wobble = keyframes`
  0%, 100% { transform: rotate(-2.5deg); }
  50%      { transform: rotate(2.5deg); }
`;

export const heartBreak = keyframes`
  0%   { transform: scale(1) rotate(0deg); opacity: 1; }
  35%  { transform: scale(1.35) rotate(-12deg); }
  100% { transform: scale(0.6) rotate(18deg); opacity: 0.28; }
`;

export const shimmer = keyframes`
  0%   { background-position: 0% 50%; }
  50%  { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

export const riseIn = keyframes`
  from { transform: translateY(14px); opacity: 0; }
  to   { transform: translateY(0);    opacity: 1; }
`;

/** Shared helper so cards animate in consistently. */
export const enterAnimation = css`
  animation: ${riseIn} 380ms ${({ theme }) => theme.transitions.bounce} both;
`;

/*
 * Note: the Baloo 2 / Quicksand webfonts are pulled in via <link> tags in
 * index.html rather than an @import here — styled-components cannot hoist
 * @import through the CSSOM APIs it uses in production, and warns about it.
 */
export const GlobalStyle = createGlobalStyle`
  *, *::before, *::after { box-sizing: border-box; }

  html, body, #root { height: 100%; }

  body {
    margin: 0;
    font-family: ${({ theme }) => theme.fonts.body};
    color: ${({ theme }) => theme.colors.ink};
    background:
      radial-gradient(1200px 800px at 15% -10%, ${({ theme }) => theme.colors.skyDeep} 0%, transparent 55%),
      radial-gradient(1000px 700px at 95% 10%, #e6f7ff 0%, transparent 50%),
      radial-gradient(900px 900px at 50% 110%, #fff0f6 0%, transparent 60%),
      ${({ theme }) => theme.colors.sky};
    background-attachment: fixed;
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
    overflow-x: hidden;
  }

  button, input, select, textarea {
    font: inherit;
    color: inherit;
  }

  button { cursor: pointer; border: none; background: none; }
  button:disabled { cursor: not-allowed; }

  h1, h2, h3, h4, p { margin: 0; }

  /* Keyboard users get a clearly visible ring; mouse users never see it. */
  :focus-visible {
    outline: 3px solid ${({ theme }) => theme.colors.lavenderDeep};
    outline-offset: 3px;
    border-radius: ${({ theme }) => theme.radii.sm};
  }

  ::selection {
    background: ${({ theme }) => theme.colors.bubblegum};
    color: #fff;
  }

  /* Soft, rounded scrollbars to match everything else. */
  ::-webkit-scrollbar { width: 10px; height: 10px; }
  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.bubblegum};
    border-radius: 999px;
  }
  ::-webkit-scrollbar-track { background: transparent; }

  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
      animation-duration: 0.001ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.001ms !important;
    }
  }
`;
